var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{staticClass:"commonModal",attrs:{"closable":false,"visible":_vm.getIsOpenPopup,"destroyOnClose":true,"footer":null,"width":_vm.getWidthPopup},on:{"cancel":_vm.handleOk}},[_c(_vm.getNamePopup,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }